<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="searchrow">
        <div class="srowleft">
          <input type="text" placeholder="请输入关键词" class="searchinput" v-model="listword">
          <img src="../../assets/images/ztsearchicon.png" />
        </div>
        <div class="srowright">
          <button class="searchbtn" @click="getsearchword">搜索</button>

        </div>
      </div>
      <!-- <div class="banner">
        <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="#333333"> -->
      <!-- <van-swipe-item>
            <img class="banner-img" :src="baseURL + details.ImgUrl" />
          </van-swipe-item> -->
      <!-- <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="toBanner(item.Type, item.Url)">
            <img class="banner-img" :src="baseURL + item.Img" />
          </van-swipe-item>
        </van-swipe>
      </div> -->
      <div class="square_consult">
        <!-- <div class="square_consult_title">在线直播</div> -->
        <div class="square_tab_scroll" ref="wrapper">
          <div class="square_tab_wrapper">
            <span :class="{ 'active': SubjectTCode == 1 }" @click="changeTab(1)">全部</span>
            <span :class="{ 'active': SubjectTCode == 2 }" @click="changeTab(2)">我的关注</span>
          </div>
        </div>
        <div class="square_consult_box">
          <div class="right_Consult" v-for="(item, index) in list" :key="index">
            <div class="livetiaozhuan">
              <div class="picture" @click="tolivelist(item.SubjectCode, item.SubjectTCode)">
                <img :src="baseURL + item.CoverUrl" />
                <div class="ptext">{{ item.Title }}</div>
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  <!-- <span class="top" v-if="item.IsTop">置顶</span> -->
                </div>
                <div class="worktype">
                  <!-- v-if="item.StatusStr == '未开始'" -->
                  <button class="yybtn" @click.stop="yybtnfunc(item.SubjectId, item.IsWatch)"
                    v-if="SubjectTCode == 1 && item.IsWatch == false">关注</button>
                  <button class="yybtn" @click.stop="yybtnfunc(item.SubjectId, item.IsWatch)"
                    v-if="SubjectTCode == 1 && item.IsWatch == true">取关</button>
                  <button class="yybtn" @click.stop="yybtnfunc(item.SubjectId, item.IsWatch)"
                    v-if="SubjectTCode == 2">取关</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <img class="share" src="../../assets/images/circle_share.png" @click="showSharePanel = true" />
    <SharePanel :show="showSharePanel" @close="closeSharePanel" />
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import SharePanel from '@/components/sharePanel.vue'
export default {
  name: 'HotspotInformation',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      details: {},
      bannerList: [],
      SubjectTCode: 1,
      list: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 //每页数据条数,默认10
        },
        noMoreSize: 0,
        toTop: {
          warpId: 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        }
      },
      showSharePanel: false,
      listword: "",
      subList: [],
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    SharePanel
  },
  computed: {
  },
  watch: {
    SubjectTCode() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
  },
  created() {
    this.initShare("华肤荟", "有心有料有趣有爱");
    document.title = "华肤荟";
    if (this.code) {
      this.getColumn();
    }
  },
  methods: {
    toBanner(type, url) {
      if (type == 20) {
        this.$router.push({
          path: 'live',
          query: {
            id: url,
            type: 1
          }
        });
      } else {
        location.href = url;
      }
    },
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    getColumn() {
      this.$axios.get(`/api/api/web/content/SubjectDetail?code=${this.code}`).then(res => {
        this.details = res.Data;
        this.initBScroll();
        this.initShare(this.details.Title);
      })
    },
    changeTab(type) {
      this.SubjectTCode = type;
    },
    getList(PageIndex, PageSize) {
      let that = this;
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      if (this.SubjectTCode == 1) {
        this.$axios.post('/api/api/web/content/LiveSubjectSearchList', {
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          Title: that.listword
        }).then(res => {
          if (PageIndex === 1) this.list = []
          this.list = this.list.concat(res.Data.List);
          this.$nextTick(() => {
            this.mescroll.endSuccess(res.Data.List.length)
          })
        })
      } else if (this.SubjectTCode == 2) {
        this.$axios.post('/api/api/web/content/MyLiveWatchList', {
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
        }).then(res => {
          if (PageIndex === 1) this.list = []
          this.list = this.list.concat(res.Data.List);
          this.$nextTick(() => {
            this.mescroll.endSuccess(res.Data.List.length)
          })
        })
      }
    },
    yybtnfunc(id, iw) {
      let that = this;
      this.$axios.get('/api/api/web/content/WatchSubject?id=' + id).then(res => {
        console.log(res)
        if (res.RetCode == 10000) {
          if (this.SubjectTCode == 1 && iw == true) {
            this.$dialog
              .alert({
                title: "提示",
                message: "取关成功！",
              })
              .then(() => {
                this.getList(1, 10);
              });
          } else if (this.SubjectTCode == 1 && iw == false) {
            this.$dialog
              .alert({
                title: "提示",
                message: "关注成功！",
              })
              .then(() => {
                this.getList(1, 10);
              });
          } else {
            this.$dialog
              .alert({
                title: "提示",
                message: "取关成功！",
              })
              .then(() => {
                this.getList(1, 10);
              });
          }
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: "操作失败，请稍后再试",
            })
            .then(() => {
            });
        }
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    getsearchword() {
      this.getList(1, 10);
    },
    // 上拉回调
    upCallback(page) {
      this.getList(page.num, page.size);
    },
    toztmore() {
      this.$router.push({
        path: 'ztmorelist',
      });
    },
    toDetail(info) {
      console.log('跳转详情')
      if (info.isOuterChain) {
        location.href = info.outerChain;
      } else {
        this.$router.push({
          path: 'informationDetails',
          query: {
            code: info.Code
          }
        });
      }
    },
    toLive(id) {
      // console.log("tz")
      this.$router.push({
        path: 'live',
        query: {
          id: id,
          type: this.SubjectTCode,
        }
      });

    },
    tolivelist(code, Tcode) {
      this.$router.push({
        path: 'liveList',
        query: {
          code: code,
          Tcode: Tcode
        }
      });
    },
    closeSharePanel() {
      this.showSharePanel = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #fff;
  padding: 12px;
  box-sizing: border-box;

  .banner {
    .banner-swipe {
      .banner-img {
        display: block;
        width: 100%;
      }
    }
  }

  .square_consult {
    .square_consult_title {
      color: #1f2b5b;
      font-size: 18px;
      font-weight: 600;
      margin: 15px 0 10px;
    }

    .square_tab_scroll {
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      margin-bottom: 8px;
      margin-top: .3rem;
      padding: 6px 0;

      .square_tab_wrapper {
        white-space: nowrap;
      }

      span {
        position: relative;
        color: #435361;
        font-size: 16px;
      }


      span:not(:first-of-type) {
        margin-left: 20px;
      }

      .active {
        color: #1D2A5A;
      }

      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -6px;
        transform: translateX(-16px);
        width: 32px;
        height: 3px;
        border-radius: 3px;
        background: #1f2b5b;
      }
    }

    /* 隐藏水平滚动条 */
    .square_tab_scroll::-webkit-scrollbar {
      display: none;
    }

    .square_consult_box {
      position: relative;

      .right_Consult {
        // display: flex;
        border-radius: 8px;
        box-shadow: 0 5px 8px 0 rgba(0, 0, 0, .04);
        margin-bottom: 10px;
        padding: 10px;
        background-color: #FFFFFF;
        box-sizing: border-box;
        padding-bottom: 0;

        .base {
          display: flex;
          flex-direction: row;
          // justify-content: space-between;
          flex: 1;
          padding: 0.2rem 3%;
          // position: relative;
          align-items: center;

          .red {
            color: red;
          }

          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;
            width: 75%;

            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }

          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 3%;

            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;

              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }

              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }

            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }

        .picture {
          flex-shrink: 0;
          width: 100%;
          // height: 80px;
          border-radius: 10px;
          overflow: hidden;
          // margin-left: 10px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          position: relative;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .share {
    position: fixed;
    right: 10px;
    bottom: 120px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
}

.searchrow {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.srowleft {
  width: 84%;
  position: relative;

  img {
    display: block;
    width: 7%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 3%;
  }
}

.srowright {
  width: 15%;
  display: flex;
}

.searchinput {
  width: 100%;
  border: 0;
  border-radius: 0.133333rem;
  padding: 0.2rem 0.2rem;
  box-sizing: border-box;
  background: #f7f8fc;
  padding-left: 12%;
}

.searchbtn {
  width: 100%;
  border: 0;
  background: #fff;
  border-radius: 0.133333rem;
  padding: 0.1rem 0;
  color: #23295f;
  font-weight: bold;
}

.square_consult_title {
  color: #1f2b5b;
  font-size: 18px;
  font-weight: 600;
  margin: 15px 0 10px;
  position: relative;
}

.ztxscroll {
  width: 100%;
  overflow-x: scroll;
  display: flex;
  flex-wrap: nowrap;
}

.ztx_item {
  width: 80%;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.ztximg {
  display: block;
  width: 100%;
}

.ztxrow {
  display: flex;
  flex-direction: row;
  padding: 0.3rem 0.2rem;
}

.ztxtitle {
  width: 78%;
  color: #1f2b5b;
  margin-right: 2%;
  display: flex;
  align-items: center;
}

.ztxbtnout {
  width: 20%;
  text-align: center;
}

.ztxguanzhu {
  background: rgb(62, 152, 230);
  border: 0;
  color: #fff;
  width: 100%;
  padding: 0.2rem 0;
}

.ztmore {
  font-size: .4rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.livetiaozhuan {
  display: flex;
  flex-direction: column;
}

.yybtn {
  background: #23295f;
  color: #fff;
  font-size: .4rem;
  border: 0;
  padding: 0.08rem 0.2rem;
  z-index: 99;
  position: relative;
  border-radius: 50px;
  width: 100%;
}

.worktype {
  font-size: 17px;
  color: #959595;
  width: 25%;
}

.ptext {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  width: 100%;
  padding: 0.1rem;
  text-align: center;
}
</style>